import React from "react";
import classnames from "classnames";

import { DATE_FNS_SHORT_DATE_FORMAT } from "../../../shared/constants";
import { Task, taskTypeToLabelMap } from "../../../shared/taskTypeMap";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive } from "@fortawesome/free-solid-svg-icons";

const Note = ({ allowArchive, archiveNote, displayNoteType, note }) => {
    const createdOrUpdatedOnText = note.updatedOn ? "Updated On" : "Created On";
    const createdOrUpdatedOnDate = note.updatedOn ? note.updatedOn : note.createdOn;
    const noteType = note.taskType ? taskTypeToLabelMap[note.taskType] : "All";
    const groupIdentifier = note.noteType === "Shipment" ? note.shipmentKey : note.binTrackingNumber;
    const createdOrUpdatedByText = note.updatedBy ? "updated by" : "added by";
    const createdOrUpdatedBy = note.updatedBy ? note.updatedBy : note.createdBy;
    const isClient = note.noteType === Task.CLIENT;

    return (
        <div className={classnames("note", { "-inactive": !note.isActive })}>
            <div>
                <b>{note.note}</b>
                <br />
                <small>
                    {createdOrUpdatedByText} {createdOrUpdatedBy}
                </small>
            </div>
            {displayNoteType && (
                <div
                    title={isClient ? note.clientName : groupIdentifier}
                    className="note-ellipsis"
                >
                    {isClient ? note.clientName : groupIdentifier}
                    <br />
                    <small>{note.noteType}</small>
                </div>
            )}
            <div>
                {format(new Date(createdOrUpdatedOnDate), DATE_FNS_SHORT_DATE_FORMAT)}
                <br />
                <small>{createdOrUpdatedOnText}</small>
            </div>
            <div>
                {noteType}
                <br />
                <small>Task</small>
            </div>
            {allowArchive && note.isActive && (
                <div>
                    <button
                        className="button -text"
                        onClick={() => {
                            archiveNote(note.noteId);
                        }}
                    >
                        <FontAwesomeIcon icon={faArchive} />
                    </button>
                </div>
            )}
        </div>
    );
};

const DisplayNotes = ({ archived, archiveNote, allowArchive, displayNoteType, notes = [] }) => {
    return (
        <div className={classnames("list-notes", { "-archived": archived })}>
            {notes.map((note) => {
                return (
                    <Note
                        key={note.noteId}
                        note={note}
                        allowArchive={allowArchive}
                        archiveNote={archiveNote}
                        displayNoteType={displayNoteType}
                    />
                );
            })}
        </div>
    );
};

export default DisplayNotes;
